module.exports = __webpack_public_path__ + "img/icon_daishenhe.33fd1d94.jpg";